<!-- eslint-disable vue/no-bare-strings-in-template -->
<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<script setup>
import { useI18n } from 'vue-i18n';
import Switch from 'dashboard/components-next/switch/Switch.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import TextArea from 'dashboard/components-next/textarea/TextArea.vue';

const props = defineProps({
  actionPolicyItems: { type: Array, default: () => [] },
  usage: { type: Object, required: true },
  isSaving: { type: Boolean, default: false },
});

const emit = defineEmits(['update:usage', 'save']);
const { t } = useI18n();

const updateUsage = (key, value) =>
  emit('update:usage', { ...props.usage, [key]: value });
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template -->
  <!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
  <div class="flex flex-col gap-6">
    <div
      class="bg-white dark:bg-n-solid-2 p-6 rounded-xl shadow-sm border border-n-strong"
    >
      <h3 class="text-lg font-semibold text-n-slate-12 mb-2">
        Integração Siprov
      </h3>
      <p class="text-sm text-n-slate-11 mb-6">
        Defina o que a LumerAI pode consultar no Siprov. As credenciais ficam em
        Configurações &gt; Integrações e nunca são exibidas depois de salvas.
      </p>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
        <div
          v-for="item in props.actionPolicyItems"
          :key="item.setting"
          class="rounded-xl border border-n-strong bg-n-alpha-1 p-4"
        >
          <div class="flex items-start justify-between gap-4">
            <div>
              <span class="block font-medium text-n-slate-12">{{
                item.title
              }}</span>
              <span class="block text-xs text-n-slate-11 mt-1">{{
                item.description
              }}</span>
            </div>
            <Switch
              :model-value="props.usage[item.setting]"
              :aria-label="item.title"
              @update:model-value="updateUsage(item.setting, $event)"
            />
          </div>
        </div>
      </div>

      <div
        class="mb-6 rounded-lg border border-n-brand/30 bg-n-brand/5 p-4 text-sm text-n-slate-11"
      >
        <p class="font-medium text-n-slate-12">Como a LumerAI decide</p>
        <p class="mt-1">
          A IA usa somente dados retornados pelo Siprov e não cria, altera,
          cancela ou aprova registros. Se faltar um identificador, ela solicita
          apenas o dado necessário e encaminha ações não disponíveis para a
          equipe responsável.
        </p>
      </div>

      <TextArea
        :model-value="props.usage.siprov_usage_instruction"
        label="Orientação geral do Siprov (opcional)"
        placeholder="Ex.: Sempre confirme o CPF ou CNPJ antes de consultar os benefícios do associado."
        :rows="4"
        :max-length="600"
        @update:model-value="updateUsage('siprov_usage_instruction', $event)"
      />

      <div class="flex justify-end mt-4">
        <Button
          :label="t('LUMERAI_SETTINGS.ACTIONS.SAVE_SIPROV_PERMISSIONS')"
          color="teal"
          :is-loading="props.isSaving"
          @click="emit('save')"
        />
      </div>
    </div>
  </div>
</template>
